import React, { Suspense } from 'react';
import { Helmet } from 'react-helmet-async';

import 'modern-css-reset';
import 'react-toastify/dist/ReactToastify.css';

import { useUser } from 'context/user';
import FullPageLoading from 'components/full-page-loading';

import 'styles/base.css';
import 'styles/variables.css';
import 'styles/fonts.css';
import 'styles/toast.css';

const Public = React.lazy(() => import('./public'));
const Private = React.lazy(() => import('./private'));

const { REACT_APP_VERSION } = process.env;

console.info('v.', REACT_APP_VERSION);
const App = () => {
  const user = useUser();
  return (
    <Suspense
      fallback={<FullPageLoading delay={300} header={false} footer={false} />}
    >
      <Helmet title={`Tweak+ ${REACT_APP_VERSION}`} />
      {user ? <Private /> : <Public />}
    </Suspense>
  );
};

export default App;
